module.exports = __webpack_public_path__ + "img/x6.c429086b.jpg";